import { useFetchBalance, useFetchTransactions } from './walletQueries'

export const usePreloadWallet = (accountId: string | null, kycComplete: boolean) => {
    useFetchBalance(accountId, { enabled: kycComplete })
    useFetchTransactions(accountId, { enabled: kycComplete })
}
